(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 80rem)');

  function setActive(root, index) {
    var panels = root.querySelectorAll('.symptoms__panel');
    panels.forEach(function (p) {
      var shouldShow = p.getAttribute('data-panel') === String(index);
      if (shouldShow) {
        if (p.hidden) {
          p.hidden = false;
        }
        p.classList.remove('is-entering');
        void p.offsetWidth;
        p.classList.add('is-entering');
      } else {
        p.hidden = true;
        p.classList.remove('is-entering');
      }
    });

    var items = root.querySelectorAll('.symptoms__list-item');
    items.forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-index') === String(index));
    });

    var activeBtn = root.querySelector('.symptoms__list-item[data-index="' + index + '"] .symptoms__list-btn');
    var label = root.querySelector('[data-active-label]');
    if (activeBtn && label) {
      label.textContent = activeBtn.textContent.trim();
    }
  }

  function syncOpenForViewport(details) {
    if (!details) return;
    if (DESKTOP_MQ.matches) {
      details.open = true;
    } else {
      details.open = false;
    }
  }

  function setup(root) {
    if (root._symptomsInit) return;
    root._symptomsInit = true;

    var details = root.querySelector('[data-symptoms-select]');

    root.querySelectorAll('.symptoms__list-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('.symptoms__list-item');
        if (!li) return;
        var index = parseInt(li.getAttribute('data-index'), 10);
        if (isNaN(index)) return;
        setActive(root, index);
        if (details && !DESKTOP_MQ.matches) {
          details.open = false;
        }
      });
    });

    if (details) {
      details.addEventListener('click', function (e) {
        if (!DESKTOP_MQ.matches) return;
        if (e.target.closest('summary')) {
          e.preventDefault();
        }
      });
    }

    syncOpenForViewport(details);
    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', function () { syncOpenForViewport(details); });
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(function () { syncOpenForViewport(details); });
    }
  }

  function init() {
    document.querySelectorAll('[data-symptoms]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
